// extracted by mini-css-extract-plugin
module.exports = {"list":"ProductListSkeleton_list__1Bnp9","isDesktop":"ProductListSkeleton_isDesktop__2rJkz"};